import TheoryArticleView from '~/encyclopedia/views/TheoryArticleView'
import { FileTopic } from '~/types/theory'

import BreadCrumbs from '~/encyclopedia/components/BreadCrumbs'
import TopicMetatags from '~/components/Metadata/TopicMetatags'
import { BackButton } from '~/components/Buttons/BackButton'

export default function DrillTopicPage({
  articleBody,
  topic,
}: {
  articleBody: string
  topic: FileTopic
}): React.ReactElement {
  const { breadcrumbs } = topic
  const backButtonIndex = breadcrumbs.length - 2

  return (
    <div className="flex flex-col py-8 px-4 lg:px-8">
      <TopicMetatags topic={topic} />
      <BackButton href={breadcrumbs[backButtonIndex].path} pageTitle={breadcrumbs[backButtonIndex].h1} />
      <div className="w-full lg:w-auto lg:min-w-max mx-auto py-8 px-4 lg:px-8 sm:px-16">
        <BreadCrumbs breadcrumbs={breadcrumbs} isWhite />
        <TheoryArticleView articleBody={articleBody} topic={topic} />
      </div>
    </div>
  )
}
